// @flow

/** Returns true if the type is considered empty, or consists of elements whose values are all considered empty
 *
 * Examples:
 *
 * {} -> true
 * [] -> true
 * [1] -> false
 * {a: []} -> true
 * [{a: []}] -> true
 * [{a: [1]}] -> false
 * */

const isDeeplyEmpty = (val: mixed): boolean => {
  if (val == null) {
    return true;
  }
  if (typeof val === 'object') {
    return [...Object.values(val)].every(isDeeplyEmpty);
  }
  return false;
};

export default isDeeplyEmpty;
